export default __webpack_public_path__ + "static/fb-3ed9fb43382ae4ab4a1b6ed3b8584191.png";